module.exports = {"_default":"local.","app":"local.","main":"web.eved.com","qainternaldemo":"qainternaldemoevedonline.","internaldemo":"internaldemoevedonline.","demo":"demoevedonline.","sandbox":"sandboxevedonline.","qaproduction":"qaproductionevedonline.","reporting-team":"reporting-team.","api-team":"api-team.","workflow-team":"workflow-team.","admin-team":"admin-team.","eved-fed":"www.","dev":"qainternaldemoevedonline."}


//////////////////
// WEBPACK FOOTER
// ./src/core/api/env.json
// module id = hcMa
// module chunks = 12